<div id="login-page" fxLayout="column">
  <div id="login-page-container">
    <mat-card id="login-card">
      <mat-card-content id="login-card-content">
        <form id="login-form" [formGroup]="form" (ngSubmit)="onSubmit()">
          <h2>{{ 'login.label.title' | translate }}</h2>
          <mat-error *ngIf="loginError">
            {{ loginError | translate }}
          </mat-error>
          <mat-form-field class="full-width-input">
            <input matInput placeholder="{{ 'login.placeholder.username' | translate }}" formControlName="username"
              required>
            <mat-error *ngIf="formSubmitAttempt">
              {{ 'login.error.invalid-username' | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="full-width-input">
            <input matInput type="password" placeholder="{{ 'login.placeholder.password' | translate }}"
              formControlName="password" required>
            <mat-error *ngIf="formSubmitAttempt">
              {{ 'login.error.invalid-password' | translate }}
            </mat-error>
          </mat-form-field>
          <button id="login-button" mat-raised-button color="primary">{{ 'login.button.login' | translate }}</button>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  <mat-toolbar id="login-page-toolbar" color="primary" fxFlexOffset="auto">
    <span>
    </span>
    <div id="expanded-toolbar-right-panel" fxLayout="row">
      <div id="expanded-toolbar-right-panel-lang-container">
        <mat-select name="lang" [(ngModel)]="lang" (selectionChange)="changeLanguage($event)"
          matTooltip="{{ 'general.tooltip.language' | translate }}">
          <mat-option value="it">IT</mat-option>
          <mat-option value="en">EN</mat-option>
        </mat-select>
      </div>
    </div>
  </mat-toolbar>
</div>